import {
	Button,
	H2,
	H3,
	VArray,
	all,
	reactive,
	Button,
	Div,
	Span,
	or,
	and,
	not,
	add,
	P,
	A,
} from 'alkali'
import { get } from 'tools/request'
import Dropdown from '../generic/Dropdown'
import { docSearchQuery, structuredQuery } from 'model/SearchQuery'
import Dialog from '../generic/DialogAlkali'
import './Navbar.scss'

export class SavedSearchesDialog extends Dialog {
	get defaults() {
		return {
			head: {
				titleText: 'Saved Searches',
			},
			id: 'settings-dialog',
			loader: false,
			foot: {},
		}
	}
	ready() {
		this.body.append(
			Div(
				reactive(get('/portal/signals'))
					.whileResolving({ loading: true })
					.to(({ signals, loading }) => {
						if (loading) {
							return P('.loading-searches', [`Loading saved searches..`])
						}
						if (signals.length > 0) {
							this.footer.rightControls.append([
								A('.primary-link', {
									content: 'Edit Saved Searches',
									href: 'https://search.doctorevidence.com/',
									target: '_blank',
									rel: 'noreferrer noopener',
								}),
							])
							return Div('.result-container', [
								Div('.notes-container', [
									P(['Click one of your saved searches from']),
									A({
										content: 'DOC Search',
										href: 'https://search.doctorevidence.com/',
										target: '_blank',
										rel: 'noreferrer noopener',
									}),
									P(['to see their results in DocAnalytics']),
								]),
                                Div('.signals-container', [
								signals.map((signal) =>
									Div('.search-container', [
										Button('.search-button', {
											content: signal.title,
											onclick: () => {
												location.search =
													'query=ss(' +
													signal['signal-uuid'] +
													'.' +
													encodeURIComponent(signal.title.replace(/[\)\.\(]/g, '')) +
													')'
												this.dialog.hide()
											},
										}),
										P('.signal-description', [` - ${signal.description}`]),
									])
								)
                                ])
							
							])
						} else {
							return Div('.notes-container', [
								H3([`No saved searches from DOC Search`]),
								P([
									`To create saved searches please navigate to DOC Search using the link below`,
								]),
								A('.add-link', {
									content: 'Create your first saved search',
									href: 'https://search.doctorevidence.com/saved-searches/new',
									target: '_blank',
									rel: 'noopener',
								}),
							])
						}
					})
			)
		)
	}
}
